import { render, staticRenderFns } from "./viewLinksChats.vue?vue&type=template&id=46ca33e6&scoped=true&"
import script from "./viewLinksChats.vue?vue&type=script&lang=js&"
export * from "./viewLinksChats.vue?vue&type=script&lang=js&"
import style0 from "./viewLinksChats.vue?vue&type=style&index=0&id=46ca33e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca33e6",
  null
  
)

export default component.exports